export default "__VITE_ASSET__817f2da8__"